'use client';

import type { UIMessage } from 'ai';
import { Source, Sources, SourcesContent, SourcesTrigger } from './elements/sources';

interface MessageSourcesProps {
  message: UIMessage;
}

export function MessageSources({ message }: MessageSourcesProps) {
  const sourceUrls = message.parts?.filter((part) => part.type === 'source-url') || [];

  if (message.role !== 'assistant' || sourceUrls.length === 0) {
    return null;
  }

  return (
    <Sources>
      <SourcesTrigger count={sourceUrls.length} />
      {sourceUrls.map((part, i) => (
        <SourcesContent key={`${message.id}-${i}`}>
          <Source key={`${message.id}-${i}`} href={part.url} title={part.url} />
        </SourcesContent>
      ))}
    </Sources>
  );
}
